// import React from "react";
// import { Bar } from "react-chartjs-2";
// import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";

// ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, ChartDataLabels);

// const HorizontalBarChart = ({ data: apiData }) => {
//   const data = {
//     labels: apiData.map((item) => item?.label),
//     datasets: [
//       {
//         data: apiData.map((item) => (+item?.percentage).toFixed(2)),
//         backgroundColor: [
//           "rgba(255, 99, 132, 0.6)",
//           "rgba(54, 162, 235, 0.6)",
//           "rgba(255, 206, 86, 0.6)",
//           "rgba(75, 192, 192, 0.6)",
//           "rgba(153, 102, 255, 0.6)",
//           "rgba(255, 159, 64, 0.6)",
//         ],
//         borderColor: [
//           "rgba(255, 99, 132, 1)",
//           "rgba(54, 162, 235, 1)",
//           "rgba(255, 206, 86, 1)",
//           "rgba(75, 192, 192, 1)",
//           "rgba(153, 102, 255, 1)",
//           "rgba(255, 159, 64, 1)",
//         ],
//         borderWidth: 1,
//       },
//     ],
//   };

//   const options = {
//     indexAxis: "y",
//     responsive: true,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       datalabels: {
//         anchor: "end", // Position the label
//         align: "start", // Align label to the end of the bar
//         formatter: (value) => (+value).toFixed(2), // Format label
//         color: "black", // Ensure visibility
//         font: {
//           weight: "bold",
//         },
//       },
//       tooltip: {
//         enabled: true,
//         callbacks: {
//           label: (context) => `${context.raw}`,
//         },
//       },
//     },
//     scales: {
//       x: {
//         beginAtZero: true,
//         grid: {
//           display: false,
//         },
//         ticks: {
//           display: false,
//         },
//       },
//       y: {
//         grid: {
//           display: false,
//         },
//         ticks: {
//           color: "black", // Ensure visibility
//           font: {
//             weight: "bold",
//           },
//         },
//       },
//     },
//   };

//   return (
//     <div className="h-full w-full">
//       <Bar data={data} options={options} />
//     </div>
//   );
// };

// export default HorizontalBarChart;

// import React from "react";
// import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, PointElement } from "chart.js";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, PointElement);

// const HorizontalBarChart = ({ data: apiData }) => {
//   console.log("apiData ::", apiData);

//   const data = {
//     labels: apiData.map((item) => item?.label),
//     datasets: [
//       // Background Ranges
//       {
//         label: "Low",
//         data: [30, 30, 30, 30, 30], // Red section
//         backgroundColor: "rgba(255, 0, 0, 0.6)",
//         stack: "Stack 0",
//         datalabels: { display: false }, // Disable labels
//       },
//       {
//         label: "Medium",
//         data: [40, 40, 40, 40, 40], // Yellow section
//         backgroundColor: "rgba(255, 206, 86, 0.8)",
//         stack: "Stack 0",
//         datalabels: { display: false },
//       },
//       // (30, 130, 76);, 1
//       {
//         label: "High",
//         data: [30, 30, 30, 30, 30], // Green section
//         backgroundColor: "rgba(30, 130, 76, 0.8)",
//         stack: "Stack 0",
//         datalabels: { display: false },
//       },
//       // Black Dot Marker (Scatter Plot)
//       {
//         type: "scatter",
//         label: "Marker",
//         data: [
//           { x: 35, y: 4 },
//           { x: 45, y: 3 },
//           { x: 25, y: 2 },
//           { x: 70, y: 1 },
//           { x: 85, y: 0 },
//         ],
//         // backgroundColor: "rgba(0, 0, 0, 1)",
//         // // borderColor: "rgba(255, 255, 255, 0.9)", // White outline
//         // // borderWidth: -10, // Makes the dots pop
//         // pointBackgroundColor: 'black',
//         // pointRadius: 10, // Bigger dots for visibility
//         // pointHoverRadius: 10, // Larger hover effect
//         // pointHoverBorderWidth: 3,
//         // pointHoverBackgroundColor: "rgba(0, 0, 0, 0.9)", // Darker on hover
//         // // shadowColor: "rgba(0, 0, 0, 0.9)", // Soft glow
//         // // shadowBlur: 10, // Increases glow effect
//         backgroundColor: "rgba(0, 0, 0, 1)", // Pure black
//         pointBackgroundColor: "black",
//         pointBorderColor: "white", // White border for contrast
//         pointBorderWidth: 3, // Make the border pop
//         pointRadius: 10,
//         pointHoverRadius: 12,
//         pointHoverBorderWidth: 3,
//         pointHoverBackgroundColor: "rgba(0, 0, 0, 0.9)",
//       },
//     ],
//   };

//   const options = {
//     indexAxis: "y",
//     responsive: true,
//     scales: {
//       x: {
//         min: 0,
//         max: 100,
//       },
//       y: {
//         beginAtZero: true,
//       },
//     },
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         enabled: true,
//         filter: (tooltipItem) => tooltipItem.datasetIndex === 3, // Enable tooltip only for dots
//         callbacks: {
//           label: (context) => `Value: ${context.raw.x}%`,
//         },
//       },
//     },
//   };

//   // Custom plugin to add vertical error bars
//   const errorBarPlugin = {
//     id: "errorBars",
//     afterDraw(chart) {
//       const ctx = chart.ctx;
//       const meta = chart.getDatasetMeta(3); // Scatter dataset (dots)
//       const errorBarLength = 22; // Slightly longer error bars

//       ctx.save();
//       ctx.strokeStyle = "black";
//       ctx.lineWidth = 2;
//       ctx.lineHeight = 20
//       meta.data.forEach((point) => {
//         const { x, y } = point.getCenterPoint();

//         // Draw vertical error bar
//         ctx.beginPath();
//         ctx.moveTo(x, y - errorBarLength);
//         ctx.lineTo(x, y + errorBarLength);
//         ctx.stroke();
//       });

//       ctx.restore();
//     },
//   };

//   return <Bar data={data} options={options} plugins={[errorBarPlugin]} />;
// };

// export default HorizontalBarChart;

import React from "react";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, PointElement, ScatterController, LineController, LineElement, Title, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(ScatterController, LineController, PointElement, LineElement, LinearScale , BarElement, CategoryScale, Title, Tooltip, Legend );

const BehaviorBulletChart = ({ data: apiData }) => {

  // Extract labels and percentages from the data
  const labels = apiData.map(item => item.label);
  const percentages = apiData.map(item => parseFloat(item.percentage));

  const data = {
    labels,
    datasets: [
      {
        label: "Behavior Score",
        data: percentages.map(() => 100),
        backgroundColor: "rgba(76, 162, 223, 0.4)", // Soft Blue
        stack: "Stack 0",
        datalabels: { display: false },
        barThickness: 40,
      },
      {
        type: "scatter",
        label: "Marker",
        data: percentages.map((value, index) => ({ x: value, y: index })),
        backgroundColor: "rgba(50, 50, 50, 1)", // Dark Grey (Softer than pure black)
        pointBackgroundColor: "rgba(50, 50, 50, 1)", // Soft black
        pointBorderColor: "white",
        pointBorderWidth: 3,
        pointRadius: 7, // Slightly smaller for subtlety
        pointHoverRadius: 10,
        pointHoverBorderWidth: 3,
        pointHoverBackgroundColor: "rgba(30, 30, 30, 1)", // Darker grey on hover
      },
    ],
  };


  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        min: 0,
        max: 100,
      },
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        filter: tooltipItem => tooltipItem.datasetIndex === 1, // Enable tooltip only for dots
        callbacks: {
          label: context => `Value: ${context.raw.x.toFixed(2)}`,
        },
      },
    },
  };

  // Custom plugin to add vertical error bars
  const errorBarPlugin = {
    id: "errorBars",
    afterDraw(chart) {
      const ctx = chart.ctx;
      const meta = chart.getDatasetMeta(1); // Scatter dataset (dots)
      const errorBarLength = 18; // Slightly longer error bars

      ctx.save();
      ctx.strokeStyle = "black";
      ctx.lineWidth = 2;
      ctx.lineHeight = 20
      meta.data.forEach((point) => {
        const { x, y } = point.getCenterPoint();

        // Draw vertical error bar
        ctx.beginPath();
        ctx.moveTo(x, y - errorBarLength);
        ctx.lineTo(x, y + errorBarLength);
        ctx.stroke();
      });

      ctx.restore();
    },
  };

  return <div className="bg-white behavior-graph h-full">
    <Bar data={data} options={options} plugins={[errorBarPlugin]} />
  </div>;
};

export default BehaviorBulletChart;



